import { useNavigate, useLocation } from "react-router-dom";
import { useContext, useEffect } from "react";

import { useSignOut, AuthContext } from "@auth";
import { menuItems } from "./menu-data";

export type SideBarLogicInterface = {
  selectedPageIndex: number | undefined,
  menuItems: {
    labelKey: string;
    to: string;
    icon: {
      variant: any; // IconVariantType;
    };
  }[];
  navigateToPage: (index: number, to: string) => void;
  signOut?: () => Promise<void>;
};

export const useSideBarTemplate = (): SideBarLogicInterface => {
  const { selectedPageIndex, setSelectedPageIndex } = useContext(AuthContext);
  const signOut = useSignOut();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const normalizePath = (path: string) => path.replace(/^\/+|\/+$/g, "");
    const dashboardPrefix = "/dashboard/";
    if (!location.pathname.startsWith(dashboardPrefix)) {
      return;
    }

    const currentSegment = normalizePath(
      location.pathname.slice(dashboardPrefix.length)
    );

    const matchedIndex = menuItems.findIndex((item) => {
      const targetSegment = normalizePath(item.to);
      return currentSegment === targetSegment || currentSegment.startsWith(`${targetSegment}/`);
    });

    if (matchedIndex >= 0 && matchedIndex !== selectedPageIndex) {
      setSelectedPageIndex(matchedIndex);
    }
  }, [location.pathname, selectedPageIndex, setSelectedPageIndex]);

  const navigateToPage = (index: number, to: string) => {
    setSelectedPageIndex(index);
    navigate("/dashboard/" + to);
  }

  return {
    menuItems,
    selectedPageIndex,
    navigateToPage,
    signOut: async () => {
      await signOut();
      navigate("/signin");
    },
  };
};
